
export interface Step {
    label: string,
    completed?: boolean,
    active?: boolean,
    onClick?: () => void;
}

interface StepperProps {
    steps: Step[]
}

const Stepper: React.FC<StepperProps> = ({ steps }) => {
    return (
        <div className="d-flex align-items-center w-100 max-w-md mx-auto">
            {steps.map((step, index) => (
                <div key={index} className="d-flex align-items-center">
                    {/* Step Circle */}
                    <div
                        className={`d-flex align-items-center justify-content-center rounded-circle text-gray stepper-step ${step.active && 'active-step text-white'} ${step.completed && 'bg-success text-white'}`}
                    >
                        {step.completed ? <i className='bx bx-check' ></i> : index+1}
                    </div>

                    {/* Step Label (only for first step) */}
                    {step.active && (
                        <span className="ms-2 text-dark stepper-label">
                            {step.label}
                        </span>
                    )}

                    {/* Dashed Connector */}
                    {index < steps.length - 1 && (
                        <div className="flex-grow-1 mx-2 stepper-connecting-line completed-connecting-line"></div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Stepper;